import { object, string } from 'yup';

import { getFormValidator } from '@util/form/get-form-validator';

export const sequenceFormValidation = getFormValidator(
  object().shape({
    method: string().required(),
    url: string().required().url(),
  }),
);
